/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type MasterDirectoryLocationsBySkillQueryVariables = Types.Exact<{
  skill: Types.Scalars['String']['input'];
}>;

export type MasterDirectoryLocationsBySkillQuery = {
  __typename?: 'Query';
  jobsLinkBoxSkillTopLocations?: Array<{
    __typename?: 'JobsLinkBoxLocation';
    location?: {
      __typename?: 'JobsLinkBoxLocationLocation';
      name?: string | null;
    } | null;
  } | null> | null;
};

export const MasterDirectoryLocationsBySkillDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MasterDirectoryLocationsBySkill' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'skill' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobsLinkBoxSkillTopLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'skill' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'skill' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MasterDirectoryLocationsBySkillQuery,
  MasterDirectoryLocationsBySkillQueryVariables
>;
